import { EmiCalculator } from '../../modules/emiCalculator'
import { FormBuilder } from '../../modules/formBuilder'
import { HDFCConsent } from '../../modules/hdfcConsent'
import { LoadingScreen } from '../../modules/loadingScreen'
import { StatusScreen } from '../../modules/statusScreen'

export const hdfcStateMap = {
  CC_START: {
    Component: LoadingScreen,
    props: {
      subTitle:
        'Please wait while we are checking your eligibility with HDFC Bank',
    },
  },
  HDFC_FI_CUSTOMER_BASIC_DETAILS: {
    Component: FormBuilder,
  },
  HDFC_FI_EMPLOYMENT_DETAILS: {
    Component: FormBuilder,
  },
  HDFC_FI_CUSTOMER_ADDRESS_DETAILS: {
    Component: FormBuilder,
  },
  HDFC_FI_CUSTOMER_REFERENCE_DETAILS: {
    Component: FormBuilder,
  },
  HDFC_FI_CUSTOMER_IDENTITY_PROOF: {
    Component: FormBuilder,
  },
  HDFC_FI_CUSTOMER_ADDRESS_PROOF: {
    Component: FormBuilder,
  },
  HDFC_FI_CUSTOMER_INCOME_PROOF: {
    Component: FormBuilder,
  },
  HDFC_FI_CUSTOMER_BANK_STATEMENT: {
    Component: FormBuilder,
  },
  HDFC_FI_APPLICATION_REJECT: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Application has been rejected',
        subTitle:
          'HDFC Bank application got rejected due to eligibility criteria',
        image: 'REJECTED',
      },
    },
  },
  HDFC_FI_APPLICATION_STATUS_SUBMITTED: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Application has been submitted',
        subTitle:
          'HDFC team coardinate with customer for KYC and further steps',
        image: 'APPLICATION',
      },
    },
  },
  HDFC_FI_APPLICATION_STATUS_REUPLOAD: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Documents uploaded are not verified',
        subTitle:
          'HDFC Bank executive will contact you for completion of Income Verification. You can reach out to HDFC Bank Customer Care at 1860 419 5555',
        image: 'INCORRECT_DETAILS',
      },
    },
  },
  HDFC_FI_APPLICATION_STATUS: {
    Component: StatusScreen,
    props: {
      status: {
        title: 'Documents uploaded are not verified',
        subTitle:
          'HDFC Bank executive will contact you for completion of Income Verification. You can reach out to HDFC Bank Customer Care at 1860 419 5555',
        image: 'INCORRECT_DETAILS',
      },
    },
  },
  HDFC_FI_CUSTOMER_DATA_SHARE_CONSENT_DETAILS: {
    Component: HDFCConsent,
  },
  HDFC_FI_CUSTOMER_LOAN_REQUIREMENTS: {
    Component: EmiCalculator,
  },
}
